import { Outlet } from 'react-router-dom';
import { AuthProvider } from './auth/AuthProvider';

const Auth0ProviderWithHistory = () => {
  return (
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  );
};

export default Auth0ProviderWithHistory;
